import React, { PureComponent } from 'react';

import { Modal, Button } from 'components';

import config from './ModalInfo.config';
import './ModalInfo.less';

class ModalInfo extends PureComponent {
  render() {
    const { visible, onClose, title, desc, btn, icon } = this.props;

    return (
      <div className="modal-confirm">
        <Modal visible={visible} onClose={onClose}>
          {icon && <img src={icon} alt="img-info" />}
          <div className="title-text">{title}</div>
          {desc && <div className="desc-text">{desc}</div>}
          <Button id="btn_closeModal" action={onClose} addClass="primary">
            {btn}
          </Button>
        </Modal>
      </div>
    );
  }
}

ModalInfo.displayName = config.displayName;
ModalInfo.defaultProps = config.defaultProps;
ModalInfo.propTypes = config.propTypes;

export default ModalInfo;
